import React, { Component }  from 'react'
import { Icon, Modal, Button, Form, Input, Select, Checkbox } from 'semantic-ui-react'

const options = [
  { key: 'm', text: 'Male', value: 'Male' },
  { key: 'f', text: 'Female', value: 'Female' },
  { key: 'o', text: 'Other', value: 'Other' },
]

class StudentsAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      middleName: '',
      lastName: '',
      extensionName: '',
      birthDate: '',
      gender: '',
      address: '',
      nickName: '',
      lrn: '',
      studentNumber: '',
      religion: '',
      placeOfBirth: '',
      mobile1: '',
      mobile2: '',
      contactPerson: '',
      contactPersonNumber: '',
      contactPersonAddress: '',
      guardianName: '',
      guardianNumber: '',
      guardianAddress: '',
      guardianOccupation: '',
      guardianOfficeAddress: '',
      beenHospitalized: false,
      hospitalReason: '',
      medicalHistory: '',
      showModal: false,
    };
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  toggle = () => this.setState(prevState => ({ beenHospitalized: !prevState.beenHospitalized }))

  handleSubmit = () => {
    const data = {
      firstName: this.state.firstName,
      middleName: this.state.middleName,
      lastName: this.state.lastName,
      extensionName: this.state.extensionName,
      birthDate: this.state.birthDate,
      gender: this.state.gender,
      address: this.state.address,
      nickName: this.state.nickName,
      lrn: this.state.lrn,
      studentNumber: this.state.studentNumber,
      religion: this.state.religion,
      placeOfBirth: this.state.placeOfBirth,
      mobile1: this.state.mobile1,
      mobile2: this.state.mobile2,
      contactPerson: this.state.contactPerson,
      contactPersonNumber: this.state.contactPersonNumber,
      contactPersonAddress: this.state.contactPersonAddress,
      guardianName: this.state.guardianName,
      guardianNumber: this.state.guardianNumber,
      guardianAddress: this.state.guardianAddress,
      guardianOccupation: this.state.guardianOccupation,
      guardianOfficeAddress: this.state.guardianOfficeAddress,
      beenHospitalized: this.state.beenHospitalized,
      hospitalReason: this.state.hospitalReason,
      medicalHistory: this.state.medicalHistory
    };
    this.props.handleSubmit(data);
    this.setState({
      firstName: '',
      middleName: '',
      lastName: '',
      extensionName: '',
      birthDate: '',
      gender: '',
      address: '',

      nickName: '',
      lrn: '',
      studentNumber: '',
      religion: '',
      placeOfBirth: '',
      mobile1: '',
      mobile2: '',
      contactPerson: '',
      contactPersonNumber: '',
      contactPersonAddress: '',
      guardianName: '',
      guardianNumber: '',
      guardianAddress: '',
      guardianOccupation: '',
      guardianOfficeAddress: '',
      beenHospitalized: false,
      hospitalReason: '',
      medicalHistory: ''

    })
    this.closeModal();
  }

  closeModal = () => this.setState({ showModal: false })

  openModal = () => this.setState({ showModal: true })

  render() {

    return (
      <Modal
        trigger={
          <Button icon labelPosition='right' color='green' onClick={this.openModal}> <Icon name='add' />
          Add Student
          </Button>
        }
        open={this.state.showModal}
        onClose={this.closeModal}
        closeIcon
        >
        <Modal.Header>Add a Student</Modal.Header>
        <Modal.Content scrolling>
        <Form>
          <Form.Group widths='equal'>
            <Form.Field control={Input} value={this.state.firstName} name='firstName' label='First name' placeholder='First name' onChange={this.handleChange}/>
            <Form.Field control={Input} value={this.state.middleName} name='middleName' label='Middle name' placeholder='Middle name' onChange={this.handleChange}/>
            <Form.Field control={Input} value={this.state.lastName} name='lastName' label='Last name' placeholder='Last name' onChange={this.handleChange}/>
            <Form.Field control={Input} value={this.state.extensionName} name='extensionName' label='Extension name' placeholder='Extension name' onChange={this.handleChange}/>
          </Form.Group>
          <Form.Group widths='equal'>
            <Form.Field control={Input} value={this.state.nickName} name='nickName' label='Nickname' placeholder='Nickname' onChange={this.handleChange}/>
            <Form.Field control={Input} value={this.state.lrn} name='lrn' label='LRN' placeholder='LRN' onChange={this.handleChange}/>
            <Form.Field control={Input} value={this.state.studentNumber} name='studentNumber' label='Student #' placeholder='00-0000' onChange={this.handleChange}/>
          </Form.Group>
          <Form.Group widths='equal'>
            <Form.Field>
              <label>Birthdate</label>
              <Input value={this.state.birthDate} name='birthDate' type='date' placeholder='Birthdate' onChange={this.handleChange}/>
            </Form.Field>
            <Form.Field value={this.state.gender} name='gender' control={Select} label='Gender' options={options} placeholder='Gender' onChange={this.handleChange}/>
            <Form.Field control={Input} value={this.state.religion} name='religion' label='Religion' placeholder='Religion' onChange={this.handleChange}/>
            <Form.Field control={Input} value={this.state.placeOfBirth} name='placeOfBirth' label='Place Of Birth' placeholder='Place Of Birth' onChange={this.handleChange}/>

          </Form.Group>
          <Form.Group widths='equal'>
            <Form.Field control={Input} value={this.state.mobile1} name='mobile1' label='Mobile Number 1' placeholder='Mobile Number 1' onChange={this.handleChange}/>
            <Form.Field control={Input} value={this.state.mobile2} name='mobile2' label='Mobile Number 2' placeholder='Mobile Number 2' onChange={this.handleChange}/>
          </Form.Group>
          <Form.Field value={this.state.address} name='address' control={Input} label='Address' placeholder='Address' onChange={this.handleChange}/>
          <h4> Contact Person in case of Emergency</h4>
          <Form.Group widths='equal'>
            <Form.Field control={Input} value={this.state.contactPerson} name='contactPerson' label='Name' placeholder='Name' onChange={this.handleChange}/>
            <Form.Field control={Input} value={this.state.contactPersonNumber} name='contactPersonNumber' label='Contact Number' placeholder='Contact Number' onChange={this.handleChange}/>
            <Form.Field control={Input} value={this.state.contactPersonAddress} name='contactPersonAddress' label='Address' placeholder='Address' onChange={this.handleChange}/>
          </Form.Group>

          <h4> Guardian</h4>
          <Form.Group widths='equal'>
            <Form.Field control={Input} value={this.state.guardianName} name='guardianName' label='Name' placeholder='Name' onChange={this.handleChange}/>
            <Form.Field control={Input} value={this.state.guardianNumber} name='guardianNumber' label='Contact Number' placeholder='Contact Number' onChange={this.handleChange}/>
            <Form.Field control={Input} value={this.state.guardianAddress} name='guardianAddress' label='Address' placeholder='Address' onChange={this.handleChange}/>
          </Form.Group>
          <Form.Group widths='equal'>
            <Form.Field control={Input} value={this.state.guardianOccupation} name='guardianOccupation' label='Occupation' placeholder='Occupation' onChange={this.handleChange}/>
            <Form.Field control={Input} value={this.state.guardianOfficeAddress} name='guardianOfficeAddress' label='Office Address' placeholder='Office Address' onChange={this.handleChange}/>
          </Form.Group>
          <h4> Medical History </h4>
          <Form.Group widths='equal'>
            <Form.Field control={Checkbox} checked={this.state.beenHospitalized} name='beenHospitalized' label='Have Been Hospitalized' onChange={this.toggle}/>
            <Form.Field control={Input} value={this.state.hospitalReason} name='hospitalReason' label='Reason' placeholder='Reason' onChange={this.handleChange}/>
            <Form.Field control={Input} value={this.state.medicalHistory} name='medicalHistory' label='Medical History' placeholder='Medical History' onChange={this.handleChange}/>

          </Form.Group>
        </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.handleSubmit()}>Submit</Button>
        </Modal.Actions>
      </Modal>
    )
  }
};

export default StudentsAdd;
